export default __webpack_public_path__ + "static/media/edit_article.3afad6b3.svg";